module.exports = __webpack_public_path__ + "img/icon_business_index.42e9f14d.svg";